import React, { useEffect, useCallback } from "react";

import { useMutation } from "@apollo/client";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

// Graphql
import { ONWATER } from "api/mutations";
import { Watering } from "api/types";
import { Modal } from "components";
// State
import Storage from "services/Storage";
import { snackbarState, modalWaterState, geolocationState, treesQueryVarState } from "state/atoms";

import TemplateHeader from "./components/TemplateHeader";

interface TemplateProps {
  isLoginPage?: boolean;
  children?: React.ReactNode;
}

const Template: React.FC<TemplateProps> = ({ children, isLoginPage }) => {
  const [snack, setSnack] = useRecoilState(snackbarState);
  const [mainQueryVars, setMainQueryVars] = useRecoilState(treesQueryVarState);
  const [modalState, setModalState] = useRecoilState(modalWaterState);
  const [location, setLocation] = useRecoilState(geolocationState);

  function onCloseModalWater() {
    setModalState((p) => ({ ...p, open: false }));
  }

  const [onWaterMutate, { loading }] = useMutation<{
    createWatering: Watering;
  }>(ONWATER, {
    // update: (cache, { data }) => {
    //   const response = cache.readQuery<{ trees: Tree[] }>({
    //     query: TREES,
    //     variables: homeQueryTreeVars,
    //   });
    //   if (response?.trees && data?.createWatering) {
    //     let { trees } = response;
    //     const { createWatering } = data;
    //     trees = trees.filter((tr) => tr.id !== createWatering.treeId);
    //     cache.writeQuery<{ trees: Tree[] }>({
    //       query: TREES,
    //       variables: homeQueryTreeVars,
    //       data: {
    //         trees,
    //       },
    //     });
    //   }
    // },
  });

  const navigate = useNavigate();

  const getLocation = useCallback(() => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      // console.log("coords: ", coords);
      setLocation({
        latitude: coords.latitude,
        longitude: coords.longitude,
      });
    });
  }, [setLocation]);

  const getDaysFromStorage = useCallback(() => {
    const days = Storage.getDaysDelayed();
    setMainQueryVars((p) => ({ ...p, daysDelayed: days }));
  }, [setMainQueryVars]);

  useEffect(() => {
    getDaysFromStorage();
  }, [getDaysFromStorage]);

  useEffect(() => {
    getLocation();
    const intervalId = setInterval(() => {
      getLocation();
    }, 60 * 1000);
    return () => clearInterval(intervalId);
  }, [getLocation]);

  async function onWater() {
    try {
      const { data } = await onWaterMutate({
        variables: {
          id: modalState.id,
          daysDelayed: mainQueryVars.daysDelayed,
          showNextTree: modalState.showNextId,
          ...(location.longitude && {
            ...location,
          }),
        },
      });
      setSnack({
        open: true,
        type: "success",
        message: "Watered!",
      });
      if (data?.createWatering?.tree?.nextTreeId) {
        navigate(`/detail/${data.createWatering.tree.nextTreeId}`);
      }
      onCloseModalWater();
    } catch (error) {
      onCloseModalWater();
      setSnack({
        open: true,
        type: "error",
        message: "Ops, some error occurred",
      });
    }
  }

  function onCloseSnack() {
    setSnack((prev) => ({
      ...prev,
      open: false,
    }));
  }

  function renderSnack() {
    return (
      <Snackbar open={snack.open} autoHideDuration={1500} onClose={onCloseSnack}>
        <Alert variant="filled" severity={snack.type} onClose={onCloseSnack} color={snack.type}>
          {snack.message}
        </Alert>
      </Snackbar>
    );
  }

  if (isLoginPage) {
    return (
      <>
        {children}
        {renderSnack()}
      </>
    );
  }

  return (
    <>
      <TemplateHeader />
      {children}
      {renderSnack()}
      <Modal
        open={modalState.open}
        loading={loading}
        onBack={onCloseModalWater}
        onSuccess={onWater}
        title="Confirm Watering?"
      />
    </>
  );
};

export default Template;
